module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "badgeMod"
  }, [_vm._v("\n  " + _vm._s(_vm.text) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6845a75e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/badge/src/badge.vue
// module id = 541
// module chunks = 0